import { FieldType } from "@shared/features/form/Form";
import { QuizQuestion } from "@platform/types/quiz.types";
import { mapQuestionTypeToComponentAndProps } from "./mapQuestionTypeToComponentAndProps";
import { makeQuizQuestionInputKey } from "../../utils/makeQuizQuestionInputKey";

export const makeQuestionSetFormFields = (
  questions: QuizQuestion[]
): FieldType[] => {
  return questions.map(
    ({
      id,
      required,
      prompt,
      choices,
      type,
      validation_rules,
      config_object,
      image,
      question_logic,
    }) => {
      return {
        id,
        name: makeQuizQuestionInputKey(id),
        label: prompt,
        choices,
        type,
        required,
        validation_rules,
        image,
        labelVariant: "body1",
        question_logic,
        ...mapQuestionTypeToComponentAndProps(
          choices,
          type,
          config_object,
          validation_rules
        ),
      };
    }
  );
};

export default makeQuestionSetFormFields;
